export default __webpack_public_path__ + "static/media/waffle2.c268f902.png";